import { Component, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, CanDeactivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from './authentication.service';
import { RoleName } from '@aifs-shared/user/user';
import { PortalUserService } from '@aifs-shared/portal/portal-user-service';
import { StorageWrapperService } from '@aifs-shared/cache/storage-wrapper.service';
import { Observable } from 'rxjs';

export const authGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const authService = inject(AuthenticationService);
    const portalUserService = inject(PortalUserService);
    const router = inject(Router);
    const storage = inject(StorageWrapperService);

    // console.log(`authGuard.fn: route: ${route.toString()}: state: ${state.url}`);

    const user = authService.currentUser;
    const minRole = route.data['minimumRole'];
    if (user) {
        // console.log(`authGuard.fn: Logged in: ${JSON.stringify(user, null, 2)}`);
        if (minRole) {
            // console.log(`Has minimumRole requirement: ${minRole}`);
            return portalUserService.isInRoleOrAbove(minRole);
        }
        return true;
    } else { 
        console.warn(`authGuard.fn: NOT Logged in: route is ${state.url}`);
        storage.setSessionItem('redirectUrl', state.url);

        // NOTE(IAS): May need to clear out the session, cookie and local storage
        // at this point if a mangled set of credentials are stored
        storage.clearSession();
        storage.clearLocal();
        
    }

    return false;
};


export interface CanDeactivateComponent {
    canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

export const canDeactivateGuard: CanDeactivateFn<CanDeactivateComponent> = (
    component: CanDeactivateComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
) => {

    const url: string = currentState.url;
    //console.log('Url: ' + url);

    return component.canDeactivate ? component.canDeactivate() : true;
}